import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap',

    tabs: 'bg-bg-items-white mb-2 w-full gap-1',
    tab: 'h-10 px-[43px] py-2 normal-case',
    tabsWrap: 'flex cursor-grab justify-between p-1',
    additionalTab:
      'heading-m text-secondary-hover hover:text-main hover:border-main border-secondary-hover min-w-44 shrink-0 grow cursor-pointer border-b p-3 whitespace-nowrap transition-colors',
    header: 'bg-bg-items-white flex cursor-pointer px-5 py-4 normal-case',
    headerIcon: 'ml-auto',
    wrapper: '',
    content: 'w-full',
    tabHeaderIcon: '',
    title: 'heading-m lg:heading-2xl mb-6 font-medium lg:mb-4 lg:font-medium'
  },
  variants: {
    color: {
      primary: 'text-black'
    },
    view: {
      tab: {
        header: 'hidden',
        wrapper: 'order-2 !max-h-max',
        tabs: 'rounded-full'
      },
      additionalTab: {
        header: 'hidden',
        tabs: 'gap-4 bg-white',
        wrapper: 'order-2 !max-h-max'
      },
      accordion: {
        base: '-mt-2',
        tabs: 'bg-text-main-inversion mb-0 hidden',
        header:
          'bg-text-main-inversion lg:text-s mt-2 mb-0 w-full items-center px-3 py-5 text-xs leading-[140%] font-medium lg:px-5',
        content: '[&>a]:text-icon-brand pb-5',
        wrapper:
          'bg-text-main-inversion lg:text-s -mt-2.5 px-3 text-xs leading-[140%] font-[300] lg:-mt-1 lg:px-5'
      },
      auto: {
        tabs: 'hidden rounded-full md:flex',
        header: 'w-full max-md:mb-1 md:hidden',
        content: 'max-md:pb-5',
        wrapper: 'md:order-2 md:!max-h-max'
      }
    },
    active: {
      true: {
        tabHeaderIcon: 'brightness-0 invert filter'
      },
      false: {}
    }
  },
  compoundVariants: [
    {
      view: 'tab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: true,
      className: {
        additionalTab: 'border-main heading-m-bold text-main border-b-2'
      }
    },
    {
      view: 'auto',
      active: false,
      className: {
        content: 'md:hidden'
      }
    }
  ],
  defaultVariants: {
    color: 'primary'
  }
});
